import React from "react";
const SvgPoiSupermarket = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FF8703"
        d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12"
      />
      <path
        fill="#FFF"
        d="M9.645 15.009c.809 0 1.466.658 1.466 1.466a1.467 1.467 0 01-2.932 0c0-.808.659-1.466 1.466-1.466zm5.828 0c.81 0 1.467.658 1.467 1.466a1.467 1.467 0 01-2.933 0c0-.808.66-1.466 1.466-1.466zm-5.828.812a.654.654 0 100 1.305.654.654 0 000-1.305zm5.828 0a.654.654 0 100 1.305.654.654 0 000-1.305zM6.59 6c.423 0 .795.287.904.696l.098.365h10.002a.406.406 0 01.4.486l-.98 4.866a.935.935 0 01-.92.76H9.221l.077.292a.655.655 0 00.632.485h6.604a.405.405 0 110 .812H9.93a1.47 1.47 0 01-1.417-1.088L6.91 7.658a.38.38 0 01-.055-.192l.001-.006-.15-.555a.123.123 0 00-.117-.091H5.406a.406.406 0 010-.814z"
      />
    </g>
  </svg>
);
export default SvgPoiSupermarket;
